import { render } from "./delete-confirmation-dialog.vue?vue&type=template&id=0713c002"
import script from "./delete-confirmation-dialog.vue?vue&type=script&lang=js"
export * from "./delete-confirmation-dialog.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__